import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-continue-setup-mobile',
    templateUrl: './continue-setup-mobile.component.html',
    styleUrls: ['./continue-setup-mobile.component.scss'],
    standalone: false
})
export class ContinueSetupMobileComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
